import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { INBOX_API_KEY } from '@/src/components/project/Inbox2/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { BASE_PROJECT_PATH, generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}${BASE_PROJECT_PATH}/getConnectedApps`;

type GetConnectedAppsResponse =
  | Record<string, never>
  | {
    quickbooks: any;
  };

type GetConnectedAppsProps = {
  projectId: string;
};

type useGetConnectedAppsOptions = {
  projectId: GetConnectedAppsProps['projectId'];
  config?: QueryConfig<QueryFnType>;
};

export const getConnectedApps = (
  params: GetConnectedAppsProps
): Promise<GetConnectedAppsResponse> => {
  return axios.get(generateRoutePath(url, { projectId: params.projectId }), {
    params: params,
    showError: false,
  });
};

export const connectedAppsKeys = {
  list: ['connectedApps'] as const,
};

type QueryFnType = typeof getConnectedApps;

export const useConnectedApps = ({ projectId, config }: useGetConnectedAppsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [INBOX_API_KEY, ...connectedAppsKeys.list, projectId],
    queryFn: () => getConnectedApps({ projectId }),
    staleTime: Infinity,
    ...config,
  });
};
